module.exports = __webpack_public_path__ + "img/public/SiteIcons/menuIconTwo.svg?ed27c7cd";